import React, { useEffect } from "react";
import DataTable from "./DataTable";
import moment from "moment";
import { Icons } from "../constants/icon-library";
import { confirmAndDelete } from "./constants";
import { useDispatch, useSelector } from "react-redux";
import { capitalize } from "../constants/constants";
import { deleteIntegrationSetting, fetchAllIntegrationSettings } from "../features/admin/adminSlice";

function Integrations() {
  const dispatch = useDispatch();

  const { integrationsSetting } = useSelector(
    (state) => state.admin
  );

  useEffect(() => {
    dispatch(fetchAllIntegrationSettings());
  }, [dispatch]);

  const handleRemove = (uuid) => {
    confirmAndDelete({
      uuid,
      dispatch,
      deleteThunk: deleteIntegrationSetting,
      payloadBuilder: (uuid) => ({ uuid }),
      successMessage: "Integration removed successfully.",
      errorMessage: "Failed to remove integration.",
    });
  };

  const columns = [
    { label: "Integration", key: "integrationId.name" },
    { label: "User Name", key: "userId.name" },
    { label: "User Email", key: "userId.email" },
    { label: "Created At", key: "createdAt" },
    { label: "Action", key: "action" },
  ];

  const rowRenderer = (item) => (
    <tr key={item.uuid}>
      <td className="align-middle ps-3">
        {capitalize(item?.integrationName || item?.integrationId?.name || "-")}
      </td>

      <td className="align-middle ps-3">
        {item?.userId?.name || "-"}
      </td>

      <td className="align-middle ps-3">
        {item?.userId?.email || "-"}
      </td>

      <td className="align-middle ps-3">
        {moment.utc(item?.createdAt).format("MMM D, YYYY • h:mm A")}
      </td>

      <td className="align-middle text-end">
        <button
          className="btn btn-sm text-danger"
          onClick={() => handleRemove(item.uuid)}
        >
          <i className={`wb ${Icons("delete")} fs-8`} />
        </button>
      </td>
    </tr>
  );

  return (
    <div className="content">
      <div className="row">
        <div className="col-12">
          <DataTable
            title="Integrations"
            data={integrationsSetting}
            columns={columns}
            rowRenderer={rowRenderer}
          />
        </div>
      </div>
    </div>
  );
}

export default Integrations;